import React from "react";
import { Helmet } from "react-helmet";
import CatalogItem from "./CatalogItem";
import Item from "../models/item";
import { Route } from "react-router-dom";

function RecomendedItems(props: { items: Item[], exceptIds?: number[], waist?: number, length?: number, title?: string }) {
    const groupedByIdItems: Item[][] = [];

    props.items.forEach((item) => {
        if (props.exceptIds && props.exceptIds.find(id => id == item.id)) {
            return;
        }

        if (item.stockStatus == "outOfStock") {
            return;
        }

        const group = groupedByIdItems.find((group) => group[0].id == item.id);
        if (group) {
            group.push(item);
        } else {
            groupedByIdItems.push([item]);
        }
    });
    shuffle(groupedByIdItems);

    function shuffle(array: any): any {
        let currentIndex = array.length, randomIndex;

        // While there remain elements to shuffle.
        while (currentIndex != 0) {

            // Pick a remaining element.
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
        }

        return array;
    }

    return (
        <>
            {groupedByIdItems.length > 0 &&
                <section className="mt-3">
                    <h2 className="fs-5">{props.title ? props.title : "Рекомендуємо джинси Levi’s"}</h2>
                    <div className="container">
                        <ul className="row ps-0 mb-0">
                            {groupedByIdItems
                                .sort((a, b) => {
                                    const aItem = a.find(x => x.waist == props.waist && x.length == props.length);
                                    const bItem = b.find(x => x.waist == props.waist && x.length == props.length);

                                    const aRank = aItem?.stockStatus == "inStock" ? 3 : aItem?.stockStatus == "awaiting" ? 2 : aItem?.stockStatus == "outOfStock" ? 1 : 0;
                                    const bRank = bItem?.stockStatus == "inStock" ? 3 : bItem?.stockStatus == "awaiting" ? 2 : bItem?.stockStatus == "outOfStock" ? 1 : 0;

                                    return bRank - aRank;
                                })
                                .slice(0, 4) // take only 4 recommended items for seo
                                .map((itemsGroup, index) => (
                                    <li className={`col-6 col-md-4 col-lg-3 ${index > 1 ? "d-none" : ""} ${index == 2 ? "d-md-block" : ""} ${index == 3 ? "d-lg-block" : ""} border-top border-end align-top`} key={index} style={{ display: "inline-block" }}>
                                        <div className="d-block" style={{ whiteSpace: "initial" }}> {/* Hook to reset whiteSpace to prevent inheriting */}
                                            <CatalogItem
                                                item={itemsGroup.find(x => 
                                                    x.waist == props.waist && x.length == props.length) ||
                                                    itemsGroup.find(x => x.stockStatus == "inStock") ||
                                                    itemsGroup[0]}
                                                items={itemsGroup}
                                                showSizes={false}
                                                lazyLoad={true} />
                                        </div>
                                    </li>
                                ))}
                        </ul>
                    </div>
                </section>
            }
        </>
    );
}

export default RecomendedItems;